import React from 'react';
import { CloudRain, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function HivernageSection() {
  return (
    <section id="hivernage" className="relative">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <div className="relative rounded-[32px] overflow-hidden bg-gradient-to-br from-[#0e3a3a] to-[#08272a] text-[#e7f3e6] p-8 sm:p-12">
          {/* decorative clouds */}
          <div className="absolute -top-10 right-6 text-white/10 text-[180px] leading-none select-none">☁</div>
          <div className="absolute -bottom-10 right-24 text-white/10 text-[140px] leading-none select-none">☁</div>

          <div className="relative grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-300/95 text-[#0e3a3a] text-[11px] tracking-[0.16em] uppercase font-semibold">
                <CloudRain className="w-3.5 h-3.5" /> Saison spéciale · Hivernage 2026
              </div>
              <h2 className="mt-4 text-[clamp(2rem,4vw,3.6rem)] leading-[1.05] font-semibold tracking-tight text-white">
                Saison des pluies,<br /> saison de la <span className="serif-italic text-amber-300">solidarité</span>.
              </h2>
              <p className="mt-5 text-[15px] leading-[1.65] text-white/80 max-w-xl">
                L'hivernage marque le pic de l'insécurité alimentaire et des inondations au Sahel. Fodindin bonifie de <span className="text-amber-300 font-semibold">+40%</span> (jusqu'à 75 000 FCFA par don) toutes les contributions humanitaires durant cette période critique.
              </p>
              <div className="mt-7 flex flex-wrap items-center gap-6">
                <div className="flex items-end gap-2">
                  <div className="text-[44px] leading-none font-semibold text-amber-300">+40%</div>
                  <div className="text-[12px] text-white/70 pb-1">de bonus Fodindin</div>
                </div>
                <div className="text-[12.5px] text-white/70">jusqu'à <span className="font-semibold text-white">75 000 FCFA</span> par don</div>
                <div className="text-[12px] font-mono px-2.5 py-1 rounded-full bg-white/10 border border-white/15">J-97</div>
              </div>
              <div className="mt-8 flex flex-wrap gap-3">
                <Button className="btn-anim rounded-full bg-amber-300 hover:bg-amber-200 text-[#0e3a3a] h-11 px-5 font-semibold text-[14px]">
                  Voir le mur Hivernage 2026 <ArrowRight className="w-4 h-4 ml-1" />
                </Button>
                <Button variant="ghost" className="btn-anim rounded-full h-11 px-5 text-white border border-white/20 hover:bg-white/10 text-[14px]">Soutenir une cagnotte</Button>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <Tile big value="7 753 200" unit="FCFA" label="Mobilisé pendant la saison" />
              <Tile value="590 200" unit="FCFA" label="Bonifications Fodindin versées" />
              <Tile value="62" unit="" label="Donateurs solidaires" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Tile({ value, unit, label, big }) {
  return (
    <div className={`rounded-2xl bg-white/5 border border-white/10 backdrop-blur p-5 ${big ? 'sm:col-span-3' : ''}`}>
      <div className="text-[12px] uppercase tracking-wider text-white/60">{label}</div>
      <div className="mt-2 flex items-baseline gap-1.5">
        <div className="text-[28px] font-semibold tracking-tight text-white">{value}</div>
        {unit && <div className="text-[12px] text-white/70">{unit}</div>}
      </div>
    </div>
  );
}
